import m from "../../geodata/es2015/usaHigh";
window.am4geodata_usaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/usaHigh.js
// module id = null
// module chunks = 